import React, { useEffect, useState } from 'react';
import useRequest from 'utils/use-request';
import { request, myAxios } from 'utils/request';
import { TrackFrom } from './components/track-form';
import { Table, Modal, Button, Popconfirm, message } from 'antd';
import Column from 'antd/lib/table/Column';
import { Link, Route, RouteComponentProps } from 'react-router-dom';
import { getStorage } from 'utils/storage';

export const TrackListPages: React.FC<RouteComponentProps> = props => {
  const { data, error, mutate } = useRequest<TrackList>(
    '/trackify/pixel/serarch',
  );

  if (error) {
    console.log(error, 'error');
  }
  if (!data) {
    return <div>loading</div>;
  }

  return (
    <div>
      <Link to="/track-list/add">
        <Button type="primary" style={{ marginTop: 16 }}>
          {getStorage('locale') === 'en' ? '新增' : 'Create'}
        </Button>
      </Link>
      <Table<Row> dataSource={data.rows} style={{ marginTop: 16 }}>
        <Column title="Pixel ID" dataIndex="pixelId" />
        <Column
          title={getStorage('locale') === 'en' ? '目录' : 'Collection'}
          dataIndex="collectionTitle"
        />
        <Column
          title={getStorage('locale') === 'en' ? '平台' : 'Platform'}
          dataIndex="platform"
        />
        <Column
          title={getStorage('locale') === 'en' ? '创建时间' : 'Creation Time'}
          dataIndex="createdAt"
        />
        <Column<Row>
          title={getStorage('locale') === 'en' ? '操作' : 'Actions'}
          dataIndex="action"
          render={(e, record) => {
            return (
              <div>
                <Link to={`/track-list/edit/${record.id}`}>
                  {getStorage('locale') === 'en' ? '编辑' : 'Edit'}
                </Link>
                <Popconfirm
                  title={
                    getStorage('locale') === 'en'
                      ? '确定要删除该项'
                      : 'Are you sure you want to delete this item'
                  }
                  okText={getStorage('locale') === 'en' ? '是' : 'Yes'}
                  cancelText={getStorage('locale') === 'en' ? '否' : 'No'}
                  onConfirm={() => {
                    myAxios
                      .get(`/trackify/pixel/delete/${record.id}`)
                      .then(({ data }) => {
                        const { success } = data;
                        if (success) {
                          message.success(
                            getStorage('locale') === 'en'
                              ? '删除成功'
                              : 'delete success',
                          );
                          mutate();
                        } else {
                          message.error(data.message);
                          return false;
                        }
                      });
                  }}
                >
                  <Link to={''} style={{ marginLeft: 16 }}>
                    {getStorage('locale') === 'en' ? '删除' : 'Delete'}
                  </Link>
                </Popconfirm>
              </div>
            );
          }}
        />
      </Table>
      <Route
        path="/track-list/add"
        component={() => (
          <Modal
            key="add"
            visible={true}
            title={getStorage('locale') === 'en' ? '新增' : 'Create'}
            onCancel={e => {
              props.history.goBack();
            }}
            footer={null}
          >
            <TrackFrom mutate={mutate} />
          </Modal>
        )}
      />

      <Route
        path="/track-list/edit/:id"
        component={(props: RouteComponentProps<{ id: string }>) => {
          const detail = data.rows.find(
            r => r.id === parseInt(props.match.params.id),
          );
          return (
            <Modal
              key="editor"
              visible={true}
              title={getStorage('locale') === 'en' ? '编辑' : 'Editor'}
              onCancel={e => {
                props.history.goBack();
              }}
              footer={null}
            >
              <TrackFrom mutate={mutate} detail={detail} />
            </Modal>
          );
        }}
      />
    </div>
  );
};

interface TrackList {
  offset: number;
  limit: number;
  total: number;
  param: string;
  rows: Row[];
}

export interface Row {
  id: number;
  pixelId: string;
  otherParam?: any;
  platform: string;
  collection: string;
  sourceJsUrl: string;
  jsUrl: string;
  createdAt: number;
  updatedAt: number;
}
